import AppConstants from 'constants/AppConstants';

/**
 * Fetch the floorplan (tables and table combinations) for this service day
 * @param serviceDay The service day / business day for which we want the floorplan
 */
export function fetchForServiceDay(serviceDay: string): ApiAction {
  return {
    TockApi: {
      getProto: `/floorplan/serviceday/${serviceDay}`,
      type: AppConstants.CALENDAR_FLOORPLAN_FETCH_FOR_SERVICE_DAY,
    },
  };
}
